export default __webpack_public_path__ + "static/media/044-tourist.427ba2fb.svg";